import { MatchMedia } from '@helvetia/components/MatchMedia'
import Stepper from '@helvetia/components/Stepper'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { redirectionProvider } from './ContractRedirection.provider'

interface Props {
  step: number
}

const ContractStepperRaw: React.SFC<
  Props & RouteComponentProps & WithNamespaces
> = ({ history, step, t }) => {
  return (
    <MatchMedia tablet>
      <Stepper
        currentStep={step}
        steps={[
          { stepNumber: 1, labelText: t('stepper.contract1') },
          { stepNumber: 2, labelText: t('stepper.contract2') },
        ]}
        onClick={(stepNumber: number) => {
          history.push(redirectionProvider.redirectToStep(stepNumber))
        }}
      />
    </MatchMedia>
  )
}

export const ContractStepper = withNamespaces()(withRouter(ContractStepperRaw))
